import React from 'react'
import { Accordion, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { UpToDate } from './UpdateExternalContactModal'
import { UpdateExternalContactFormV2 } from './UpdateExternalContactFormV2'
import { usePanelInfos } from './hooks'

interface ExternalContactUpdateViewElementProps {
  serviceId: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  panel: { [key: string]: any }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  metadata: { [key: string]: any }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  contactSchema: { [key: string]: any }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  contactValues: { [key: string]: any }
  panelKey: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  previousContactValues: { [key: string]: any }
  onKeySelected?: (selectedKey: string, isUnselect: boolean) => void
  rootFieldId?: string
  hidePreviousValues?: boolean
  hideRootFieldHeader?: boolean
}

export const SegmentedExternalContactUpdateViewElement: React.FC<ExternalContactUpdateViewElementProps> = ({
  serviceId,
  panel,
  metadata,
  contactSchema,
  contactValues,
  panelKey,
  previousContactValues,
  onKeySelected,
  rootFieldId = 'contactValues',
  hidePreviousValues = false,
  hideRootFieldHeader = false,
}) => {
  const { icon, color, errorMessages, showUpToDateMessage, shouldDisplayStatusIcon } = usePanelInfos({
    panel,
    metadata,
    contactSchema,
    contactValues,
    key: panelKey,
    previousContactValues,
  })
  const statusIcon = <i className={`bi ${icon} ${color}`} />

  return (
    <Accordion.Item eventKey={panelKey} key={panelKey}>
      <Accordion.Header>
        <div className='d-flex align-items-center gap-2 w-100'>
          <span>{panel.name}</span>
          {errorMessages.length
            ? !showUpToDateMessage && (
                <OverlayTrigger
                  placement='top'
                  delay={{ show: 250, hide: 400 }}
                  overlay={
                    <Tooltip id={`tooltip-${panelKey}`}>
                      {errorMessages.map((msg, index) => (
                        <div key={index}>{msg}</div>
                      ))}
                    </Tooltip>
                  }
                >
                  {statusIcon}
                </OverlayTrigger>
              )
            : shouldDisplayStatusIcon && statusIcon}
        </div>
      </Accordion.Header>
      <Accordion.Body className='px-3'>
        {showUpToDateMessage ? (
          <UpToDate serviceId={serviceId} />
        ) : (
          <UpdateExternalContactFormV2
            serviceId={serviceId}
            rootFieldId={`${rootFieldId}.${panelKey}`}
            contactSchema={contactSchema[panelKey]}
            contactValues={contactValues[panelKey]}
            previousContactValues={previousContactValues[panelKey]}
            requiredSteps={panel?.['required_operation_steps'] ?? {}}
            metadata={metadata}
            onKeySelected={onKeySelected}
            hidePreviousValues={hidePreviousValues}
            hideRootFieldHeader={hideRootFieldHeader}
          />
        )}
      </Accordion.Body>
    </Accordion.Item>
  )
}
